var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs"},_vm._l((_vm.questions),function(question,index){return _c('div',{staticClass:"tab",class:[
      _vm.selected_question && _vm.selected_question.id === question.id ? 'selected' : null,
      question.is_correct_answer ? 'correct' : 'incorrect'
    ],on:{"click":function($event){return _vm.$emit('select', question)}}},[_c('span',{staticClass:"number"},[_vm._v(_vm._s(index + 1))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }